import { Alert, Button, Row, Form, Input, message, Tabs } from 'antd'
import { WeaverQueryHelperModal } from 'Components'
import { LoadingOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { useState, useEffect } from 'react'
import { useRouteMatch, useHistory } from 'react-router-dom'
import { getAppViewFromId } from 'Services/WeaverUtils'
{ TabPane } = Tabs

CreateViewForm = ({ viewType, setViewType, query }) ->

  history = useHistory()
  { params: { spaceId, viewId }} = useRouteMatch()

  [form] = Form.useForm()
  [helpModalOpen, setHelpModalOpen] = useState(false)
  [viewNode, setViewNode] = useState(undefined)
  [saving, setSaving] = useState(false)
  [error, setError] = useState(undefined)
  { Constructor } = viewType

  useEffect(->
    (->
      if viewId isnt 'new'
        node = await getAppViewFromId(viewId)
        if node
          setViewNode(node)
          form.setFieldsValue(node.attributes())
      else if query?
        query.queryType ?= viewType.queryLang
        form.setFieldsValue(query)
    )()
    undefined
  , [])

  onFinish = (fields) ->
    setSaving(true)
    try
      await viewType.FormItems.validateQuery(fields)
      viewNode ?= new Constructor()

      viewNode.set('queryType', viewType.queryLang)
      _.map(fields, (value, key) -> viewNode.set(key, value))

      await viewNode.save()
      history.push("/#{ spaceId }/settings/views")
    catch e
      if RegExp('Unexpected token').test(e.message)
        setError({
          message: "Query parsing error"
          description: "Unexpected token in query"
        })
      else
        setError({
          message: "Query parsing error"
          description: e.message
        })
      setSaving(false)

  <>
    <Form
      layout='horizontal'
      form={form}
      onFinish={onFinish}
      initialValues={{queryType: viewType.queryLang}}
    >
      <Form.Item
        name="name"
        rules={[{required: true, message: 'View name required'}]}
      >
        <Input
          size="large"
          placeholder='Name'
          data-testid="create-view-name"
        />
      </Form.Item>
      {
        if error?
          <Form.Item>
            <Alert
              type="error"
              data-testid='create-view-error'
              message={error.message}
              description={error.description}
            />
          </Form.Item>
      }
      <viewType.FormItems
        setFieldsValue={form.setFieldsValue}
        extra={
          <div className='open-helper-container'>
            <a
              data-testid="open-helper"
              onClick={-> setHelpModalOpen(true)}
            >
              <QuestionCircleOutlined /> I need help!
            </a>
          </div>
        }
        viewNode={viewNode}
      />

      <Form.Item style={{ marginBottom: 0 }}>
        <Row justify="center">
          <Button
            loading={saving}
            size="large"
            type="primary"
            shape="round"
            htmlType="submit"
            data-testid="create-view"
          >
            Save
          </Button>
        </Row>
      </Form.Item>
    </Form>

    <WeaverQueryHelperModal
      queryType={viewType.queryLang}
      visible={helpModalOpen}
      setVisible={setHelpModalOpen}
    />
  </>

export default CreateViewForm
